/**
 * Met le premier caractère en majuscule.
 * @param  String str chaine d'entrée
 * @return String chaine après modification
 */
function ucfirst(str) {
    str += ''; 
    return str.charAt(0).toUpperCase() + str.substr(1);
}


/**
 * Retire toutes les lettres accentuées les plus courantes.
 * @param  String str chaine à normaliser
 * @return String chaine avec les accents retirées
 */
function removeAccents(str) {
    var norm = new Array('\300', '\301', '\302', '\303', '\304', '\305', '\306', '\307', '\310', '\311', '\312', '\313', '\314', '\315', '\316', '\317',
        '\320', '\321', '\322', '\323', '\324', '\325', '\326', '\330', '\331', '\332', '\333', '\334', '\335', '\336', '\337', '\340',
        '\341', '\342', '\343', '\344', '\345', '\346', '\347', '\350', '\351', '\352', '\353', '\354', '\355', '\356', '\357', '\360',
        '\361', '\362', '\363', '\364', '\365', '\366', '\370', '\371', '\372', '\373', '\374', '\375', '\376', '\377');

    var spec = new Array('A', 'A', 'A', 'A', 'A', 'A', 'A', 'C', 'E', 'E', 'E', 'E', 'I', 'I', 'I', 'I',
        'D', 'N', 'O', 'O', 'O', '0', 'O', 'O', 'U', 'U', 'U', 'U', 'Y', 'b', 's', 'a',
        'a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'd',
        'n', 'o', 'o', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'b', 'y');

    for (var i = 0, max = spec.length; i < max; ++i) {
        str = str.replace(norm[i], spec[i]);
    }

    return str;
}


/**
 * Génration d'une clé unique (en fonction de la date/heure).
 * @return Int clé unique (que des chiffres)
 */
function uniqueId() {
    return Math.round(new Date().getTime() + (Math.random() * 100));
}


/**
 * Equivalent de la fonction number_format en PHP
 */
function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k).toFixed(prec);
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}


//Filtre JQUERY pour parser automatiquement les entêtes X-JSON
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (typeof jqXHR.responseJSON == 'undefined') {
        jqXHR.responseJSON = null;
    }

    options.success = function (data, textStatus, jqXHR) {
        jqXHR.responseJSON = getHeaderJSON(jqXHR);
        textStatus = jqXHR.responseJSON;
        if (typeof originalOptions.success != 'undefined' && originalOptions.success != null) {
            originalOptions.success(data, textStatus, jqXHR);
        }
    };

    options.error = function (jqXHR, textStatus, errorThrown) {
        jqXHR.responseJSON = getHeaderJSON(jqXHR);
        textStatus = jqXHR.responseJSON;

        if (typeof originalOptions.error != 'undefined' && originalOptions.error != null) {
            originalOptions.error(jqXHR, textStatus, errorThrown);
        }
    };

    options.complete = function (jqXHR, textStatus) {
        jqXHR.responseJSON = getHeaderJSON(jqXHR);
        textStatus = jqXHR.responseJSON;

        if (typeof originalOptions.complete != 'undefined' && originalOptions.complete != null) {
            originalOptions.complete(jqXHR, textStatus);
        }
    };
});


getHeaderJSON = function (xhr) {
    var json = false;
    try {
        json = xhr.getResponseHeader('X-JSON');
        if (!json) {
            var ct = xhr.getResponseHeader("content-type") || "";
            if (ct.indexOf('json') > -1) {
                json = xhr.responseText;
            }
        }
    }
    catch (e) {
    }

    if (json) {
        var data = jQuery.parseJSON(json); // or JSON.parse or whatever you like
        return data
    }

    return null;
};

// $.postJSON = function(url, data, callback) {
// 	return jQuery.ajax({
// 		'type': 'POST',
// 		'url': url,
// 		'contentType': 'application/json',
// 		'data': data,
// 		'dataType': 'json',
// 		'success': callback
// 	});
// };


function addslashes(str) {
    return (str + '')
        .replace(/[\\"']/g, '\\$&')
        .replace(/\u0000/g, '\\0')
}





function isTouchDevice() {
    return 'ontouchstart' in window        // works on most browsers
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
}




// Include CSS file
function addCSS(url){
    if (!$("link[href='"+url+"']").length) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }
}


(function($) {

    $.fn.extend({

        serializeObject : function(){
            var self = this,
                json = {},
                push_counters = {},
                patterns = {
                    "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
                    "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
                    "push":     /^$/,
                    "fixed":    /^\d+$/,
                    "named":    /^[a-zA-Z0-9_]+$/
                };


            this.build = function(base, key, value){
                base[key] = value;
                return base;
            };

            this.push_counter = function(key){
                if(push_counters[key] === undefined){
                    push_counters[key] = 0;
                }
                return push_counters[key]++;
            };

            $.each($(this).serializeArray(), function(){

                // skip invalid keys
                if(!patterns.validate.test(this.name)){
                    return;
                }

                var k,
                    keys = this.name.match(patterns.key),
                    merge = this.value,
                    reverse_key = this.name;

                while((k = keys.pop()) !== undefined){

                    // adjust reverse_key
                    reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

                    // push
                    if(k.match(patterns.push)){
                        merge = self.build([], self.push_counter(reverse_key), merge);
                    }

                    // fixed
                    else if(k.match(patterns.fixed)){
                        merge = self.build([], k, merge);
                    }

                    // named
                    else if(k.match(patterns.named)){
                        merge = self.build({}, k, merge);
                    }
                }

                json = $.extend(true, json, merge);
            });

            return json;
        }

    });


})(jQuery);